import { Box } from '@mui/material';
import { ResponsiveScatterPlot } from '@nivo/scatterplot';
import ChartSection from '../shared/ChartSection';
import useNivoTheme from '../shared/useNivoTheme';

export default function SkillVsActivity({ data }) {
    const { theme, colors } = useNivoTheme();
    if (!data || data.length === 0) return null;

    const scatterData = [{
        id: 'Members',
        data: data.map(d => ({ x: d.trades, y: d.hit_rate, name: d.name, grade: d.grade })),
    }];

    const medianTrades = data.map(d => d.trades).sort((a, b) => a - b)[Math.floor(data.length / 2)];
    const medianHitRate = data.map(d => d.hit_rate).sort((a, b) => a - b)[Math.floor(data.length / 2)];

    return (
        <ChartSection id="skill-activity" title="Who's skilled AND active?" subtitle="X = trade count, Y = hit rate (% beating SPY). Top-right quadrant = skilled and active traders worth watching.">
            <Box sx={{ height: 400 }}>
                <ResponsiveScatterPlot
                    data={scatterData}
                    margin={{ top: 20, right: 20, bottom: 60, left: 60 }}
                    xScale={{ type: 'linear', min: 0, max: 'auto' }}
                    yScale={{ type: 'linear', min: 30, max: 100 }}
                    nodeSize={7} colors={[colors.primary]}
                    axisBottom={{ legend: 'Number of Trades', legendPosition: 'middle', legendOffset: 46 }}
                    axisLeft={{ legend: 'Hit Rate (%)', legendPosition: 'middle', legendOffset: -45, format: v => v + '%' }}
                    markers={[
                        { axis: 'x', value: medianTrades, lineStyle: { stroke: colors.muted, strokeDasharray: '4 4' } },
                        { axis: 'y', value: medianHitRate, lineStyle: { stroke: colors.muted, strokeDasharray: '4 4' } },
                    ]}
                    tooltip={({ node }) => (
                        <Box sx={{ bgcolor: 'custom.surface.elevated', p: 1.5, borderRadius: 1, border: t => '1px solid ' + t.palette.custom.border.default }}>
                            <Box sx={{ fontWeight: 600, color: 'text.primary', fontSize: '0.875rem' }}>{node.data.name} ({node.data.grade})</Box>
                            <Box sx={{ color: 'text.muted', fontSize: '0.75rem' }}>{node.data.x} trades · {node.data.y}% hit rate</Box>
                        </Box>
                    )}
                    theme={theme}
                />
            </Box>
        </ChartSection>
    );
}
